module.exports = __webpack_public_path__ + "img/harlem-globetrotters.750f0aaa.jpg";